import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  header: {
    noStatus: () =>
      i18n.t(i18nKeys.privacy_manageAccount_archiveAccount_header_noStatus_new),
    hasStatus: () =>
      i18n.t(i18nKeys.privacy_manageAccount_archiveAccount_header_hasStatus),
  },
  body: {
    noStatus: () =>
      i18n.t(i18nKeys.privacy_manageAccount_archiveAccount_body_noStatus_new),
  },
  button: {
    request: () =>
      i18n.t(i18nKeys.privacy_manageAccount_archiveAccount_button_request_new),
    download: () =>
      i18n.t(i18nKeys.privacy_manageAccount_archiveAccount_button_download),
    send: () =>
      i18n.t(i18nKeys.privacy_manageAccount_archiveAccount_button_send),
  },
}
